import React from "react"

const BlogLoader = () => {
  return (
    <div className="text-center mt-auto mb-auto blog-loader">
      <div
        className="spinner-grow text-danger"
        style={{ width: "3rem", height: "3rem" }}
        role="status"
      >
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  )
}

export default BlogLoader
